import { render, staticRenderFns } from "./NotFoundPage.vue?vue&type=template&id=70390ab2&scoped=true&"
import script from "./NotFoundPage.vue?vue&type=script&lang=js&"
export * from "./NotFoundPage.vue?vue&type=script&lang=js&"
import style0 from "./NotFoundPage.vue?vue&type=style&index=0&id=70390ab2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70390ab2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ichigei/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70390ab2')) {
      api.createRecord('70390ab2', component.options)
    } else {
      api.reload('70390ab2', component.options)
    }
    module.hot.accept("./NotFoundPage.vue?vue&type=template&id=70390ab2&scoped=true&", function () {
      api.rerender('70390ab2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/pages/NotFoundPage.vue"
export default component.exports